export default __webpack_public_path__ + "static/media/goalmedal.28f925fc.svg";